import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  template: `<div class="">
    <ng-container
      *ngIf="clientData && clientData.logoContentRequest.clientLogoImg"
    >
      <img
        src="data:image/JPEG;base64,{{
          clientData.logoContentRequest.clientLogoImg
        }}"
        [ngClass]="{
          'tw-h-[75px]': onHeader,
        }"
        alt="{{ 'ClientLogoAlt' | translationClientCustomization:clientData.logoContentRequest.clientLogoAlt }}"
        tabindex="0"
        [attr.aria-label]="'ClientLogoAlt' | translationClientCustomization:clientData.logoContentRequest.clientLogoAlt"
        role="link"
        (click)="onLogoClick()"
        (keydown.enter)="onLogoClick()"
      />
    </ng-container>
  </div> `,
})
export class HeaderComponent implements OnInit {
  clientData: any;
  @Input()
  onHeader: boolean = false;
  constructor(private router: Router) {}

  async ngOnInit() {
    this.clientData = await JSON.parse(sessionStorage.getItem('clientData'));
  }

  onLogoClick(): void {
    this.router.navigate(['/']);
  }
}